var _desc, _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 39899",
    d: "M0 0L40 0L40 4.44L0 4.44L0 0ZM0 15.55L39.66 15.55L39.66 20L0 20L0 15.55ZM0 31.11L40 31.11L40 35.55L0 35.55L0 31.11Z",
    fill: "#B7B4C7",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 39899",
    d: "M40 0L40 4.44L0 4.44L0 0L40 0ZM39.66 15.55L39.66 20L0 20L0 15.55L39.66 15.55ZM40 31.11L40 35.55L0 35.55L0 31.11L40 31.11Z",
    stroke: "#707070",
    strokeOpacity: 0,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5202dc58b3c7f5b53d11361ef519b5ff.svg";
export { ForwardRef as ReactComponent };